import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from '../common';
import { IUser } from '../models';
import { IWebUserCredential } from '../models/i-web-user-credential';
import { ApiResponse, BaseResponse } from '../models/responses';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient) { }

  GetUsers(): Observable<ApiResponse<IUser[]>> {
    return this.http.get<ApiResponse<IUser[]>>(
      `${Constants.API_URL}api/User/GetUsers`)
  }

  GetUserById(Id: number): Observable<ApiResponse<IUser>> {
    return this.http.get<ApiResponse<IUser>>(
      `${Constants.API_URL}api/User/GetUserById?Id=${Id}`)
  }

  StoreUser(User: IUser): Observable<ApiResponse<number>> {
    return this.http.post<ApiResponse<number>>(
      `${Constants.API_URL}api/User/StoreUser`, User)
  }

  SetUserActive(User: IUser): Observable<BaseResponse> {
    return this.http.put<BaseResponse>(
      `${Constants.API_URL}api/User/SetUserActive`, User)
  }

  GetWebUserCredential(UserId: number): Observable<ApiResponse<IWebUserCredential>> {
    return this.http.get<ApiResponse<IWebUserCredential>>(
      `${Constants.API_URL}api/User/GetWebUserCredential?UserId=${UserId}`)
  }

  StoreWebUserCredential(WebUserCredential: IWebUserCredential): Observable<ApiResponse<number>> {
    return this.http.post<ApiResponse<number>>(
      `${Constants.API_URL}api/User/StoreWebUserCredential`, WebUserCredential)
  }
}
